module.exports = __webpack_public_path__ + "static/img/A2E_Training_Pakistan_2017SSD.708a37c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_Training_Pakistan_2017SSD.jpg
// module id = b0Ea
// module chunks = 0